export const HandleErrors = {
    install(app, options) {
        let registerErrorHandler = null;

        app.config.globalProperties.$registerErrorHandler = (handler) => {
            registerErrorHandler = handler;
        };

        app.config.errorHandler = (err, vm, info) => {
            // AppLayout already shows the reconnect notice for this one
            const isTeamleaderDisconnected = err?.response?.data?.code === 'teamleader_token_invalid';

            if (registerErrorHandler && ! isTeamleaderDisconnected) {
                registerErrorHandler();
            }

            console.log(err);
            console.log(info);
        };
    },
};
